"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETTING_FILTER = void 0;
const productType_1 = require("./productType");
exports.SETTING_FILTER = {
    CREW: productType_1.PRODUCT_TYPE.CREW,
    HOODIE: productType_1.PRODUCT_TYPE.HOODIE,
    EXTERNAL_PRODUCT: productType_1.PRODUCT_TYPE.EXTERNAL_PRODUCT,
    FACE_MASK: productType_1.PRODUCT_TYPE.FACE_MASK,
    STICKER: productType_1.PRODUCT_TYPE.STICKER,
    SUBSCRIPTION: productType_1.PRODUCT_TYPE.SUBSCRIPTION,
    TOTEBAG: productType_1.PRODUCT_TYPE.TOTEBAG,
    TSHIRT: productType_1.PRODUCT_TYPE.TSHIRT
};
//# sourceMappingURL=settingFilter.js.map